export default "__VITE_ASSET__8e22b41c__"